// extracted by mini-css-extract-plugin
module.exports = {"varSpBase":"1rem","varSpUp2":"1.5rem","footer":"footer--b3567","eventList":"eventList--4ae30","container":"container--269a2","buttonContainer":"buttonContainer--ff4f6"};